module.exports = __webpack_public_path__ + "img/40.b70bded9.png";